const Main = () => import('@/views/Main.vue')

const businessRouter = {
    path: '/business',
    name: 'Business',
    component: Main,
    icon: require(`@/assets/images/menu-icons/icon_business_20_20.png`),
    icon_active: require(`@/assets/images/menu-icons/icon_business_hover_20_20.png`),
    children: [
        {
            path: 'waybill',
            name: 'OrderManage',
            component: () => import('@/views/Business/OrderManage.vue'),
            meta: {
                title: '订单管理',
                roles: ['waybill']
            }
        },
		{
		    path: 'joinLogistics',
		    name: 'joinLogistics',
		    component: () => import('@/views/Business/joinLogistics.vue'),
		    meta: {
		        title: '加盟物流订单',
		        // roles: ['joinLogistics']
		    }
		},
        {
            path: 'take-delivery',
            name: 'LogisticsGoods',
            component: () => import('@/views/Business/LogisticsGoods.vue'),
            meta: {
                title: '物流收货确认',
                roles: ['take-delivery']
            }
        }, 
        {
            path: 'driver-monitor',
            name: 'DriverMonit',
            component: () => import('@/views/Business/DriverMonit.vue'),
            meta: {
                title: '司机监控查询',
                roles: ['driver-monitor']
            }
        },
        {
            path: 'spellList',
            name: 'SpellList',
            hidden: true,
            component: () => import('@/views/Business/SpellList.vue'),
            meta: {
                title: '拼单规则'
            }
        },
        {
            path: 'orderDetail',
            name: 'OrderDetail',
            hidden: true,
            component: () => import('@/views/Business/OrderDetail.vue'),
            meta: {
                title: '订单详情'
            }
        }, 
		{
		    path: 'LogisticsOrderDetail',
		    name: 'LogisticsOrderDetail',
		    hidden: true,
		    component: () => import('@/views/Business/LogisticsOrderDetail.vue'),
		    meta: {
		        title: '订单详情'
		    }
		}, 
        {
            path: 'orderMap',
            name: 'OrderMap',
            hidden: true,
            component: () => import('@/views/Business/OrderMap.vue'),
            meta: {
                title: '订单位置图'
            }
        },
        {
            path: 'bind-owner',
            name: 'OwnerCount',
            component: () => import('@/views/System/OwnerCount.vue'),
            meta: {
                title: '绑定货主',
                roles: ['bind-owner']
            }
        }],
    meta: {
        title: '业务管理',
        roles: ['business']
    }
}

export default businessRouter